module.exports = __webpack_public_path__ + "img/logo.6f591b38.svg";